import styled from '@emotion/styled';

import arrowBackIcon from 'src/public/img/icon-arrow-navigation-back.svg';
import completedIcon from 'src/public/img/icon-completed.svg';
import lockIcon from 'src/public/img/icon-lock-blue.svg';
import { color, font } from 'src/shared/styles/variables';

export const CardsListHeading = styled('h3')(
    {
        color: color.pickledBluewood,
    },
    font.heavy(font.size.large),
);

export const CardsListLinkHeading = styled(CardsListHeading)({
    cursor: 'pointer',
    position: 'relative',
    paddingLeft: '2.5rem',

    '&:hover': {
        opacity: 0.8,
    },
    '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        backgroundImage: `url(${arrowBackIcon})`,
        backgroundColor: 'transparent',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '1.5rem',
        height: '1rem',
        left: 0,
        top: 3,
    },
});

export const CardsList = styled('ul')({
    listStyleType: 'none',
    display: 'flex',
    flexFlow: 'row wrap',
    margin: '1rem -0.5% 3rem',
    padding: 0,
});

export interface CardWrapperProps {
    locked?: boolean;
}

export const CardWrapper = styled('li')<CardWrapperProps>(({ locked }) => ({
    display: 'flex',
    flex: '0 0 215px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    padding: '30px 10px 10px',
    margin: '0 0.5% 35px',
    width: '100%',
    border: `2px solid ${color.catskillWhite}`,
    borderRadius: '0.25rem',
    alignItems: 'flex-start',
    minWidth: '15em',
    cursor: 'auto',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        borderColor: locked ? color.gallery : color.royalBlueSaturated,
    },
}));

export const CardContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flexGrow: 1,
});

interface CardIconProps {
    iconUrl: string;
}

export const CardIcon = styled('i')<CardIconProps>(({ iconUrl }) => ({
    display: 'block',
    height: '175px',
    width: '175px',
    backgroundImage: `url('${iconUrl}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    margin: '0 auto 1rem',
}));

export const CardSmallInfo = styled('h5')(
    {
        color: color.ebonyClay,
        margin: 0,
    },
    font.book(15),
);

export const CardTitle = styled('h4')(
    {
        color: color.pickledBluewood,
        margin: 'auto 0 8px',
        lineHeight: 1.3,
        '&:first-letter': {
            textTransform: 'capitalize',
        },
    },
    font.heavy(font.size.mediumExtended),
);

export const CompletedIcon = styled('i')({
    display: 'inline-block',
    backgroundSize: 'cover',
    position: 'absolute',
    backgroundImage: `url(${completedIcon})`,
    width: 12,
    height: 12,
    right: 13,
    top: 13,
});

export const LockIcon = styled('i')({
    display: 'inline-block',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    backgroundImage: `url(${lockIcon})`,
    width: 14,
    height: 14,
    left: 'auto',
    right: 12,
    top: 12,
});
